import React from 'react'
import { FavoriteFiltersModalView } from './view'
import { IFavoriteFiltersModal } from './interfaces'

const FavoriteFiltersModal: React.FC<IFavoriteFiltersModal> = ({ children, isOpen, closeModal }) => {
  return <FavoriteFiltersModalView children={children} isOpen={isOpen} closeModal={closeModal} />
}

export default FavoriteFiltersModal
